var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_810_10947)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_810_10947)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_10947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 60.0006C39.928 60.0006 39.858 59.9922 39.788 59.9722C39.623 59.9306 23.333 55.4672 23.333 40.2989V26.6672C23.333 26.3189 23.5497 26.0056 23.878 25.8856L39.7113 20.0522C39.8963 19.9839 40.1013 19.9839 40.288 20.0522L56.1213 25.8856C56.4497 26.0056 56.6663 26.3189 56.6663 26.6672V40.2989C56.6663 55.4689 40.3763 59.9306 40.2113 59.9739C40.1413 59.9922 40.0713 60.0006 39.9997 60.0006ZM24.9997 27.2489V40.2989C24.9997 53.4356 38.083 57.7422 39.9997 58.3022C41.9163 57.7422 54.9997 53.4356 54.9997 40.2989V27.2489L39.9997 21.7222L24.9997 27.2489Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3337 45.8339H36.667C35.2887 45.8339 34.167 44.7122 34.167 43.3339V36.6672C34.167 35.2889 35.2887 34.1672 36.667 34.1672H43.3337C44.712 34.1672 45.8337 35.2889 45.8337 36.6672V43.3339C45.8337 44.7122 44.712 45.8339 43.3337 45.8339ZM36.667 35.8339C36.207 35.8339 35.8337 36.2072 35.8337 36.6672V43.3339C35.8337 43.7939 36.207 44.1672 36.667 44.1672H43.3337C43.7937 44.1672 44.167 43.7939 44.167 43.3339V36.6672C44.167 36.2072 43.7937 35.8339 43.3337 35.8339H36.667Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.167 38.3339H45.0003C44.5403 38.3339 44.167 37.9606 44.167 37.5006C44.167 37.0406 44.5403 36.6672 45.0003 36.6672H49.167C49.627 36.6672 50.0003 37.0406 50.0003 37.5006C50.0003 37.9606 49.627 38.3339 49.167 38.3339Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.167 43.3339H45.0003C44.5403 43.3339 44.167 42.9606 44.167 42.5006C44.167 42.0406 44.5403 41.6672 45.0003 41.6672H49.167C49.627 41.6672 50.0003 42.0406 50.0003 42.5006C50.0003 42.9606 49.627 43.3339 49.167 43.3339Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 38.3339H30.8333C30.3733 38.3339 30 37.9606 30 37.5006C30 37.0406 30.3733 36.6672 30.8333 36.6672H35C35.46 36.6672 35.8333 37.0406 35.8333 37.5006C35.8333 37.9606 35.46 38.3339 35 38.3339Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 43.3339H30.8333C30.3733 43.3339 30 42.9606 30 42.5006C30 42.0406 30.3733 41.6672 30.8333 41.6672H35C35.46 41.6672 35.8333 42.0406 35.8333 42.5006C35.8333 42.9606 35.46 43.3339 35 43.3339Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5003 50.0006C42.0403 50.0006 41.667 49.6272 41.667 49.1672V45.0006C41.667 44.5406 42.0403 44.1672 42.5003 44.1672C42.9603 44.1672 43.3337 44.5406 43.3337 45.0006V49.1672C43.3337 49.6272 42.9603 50.0006 42.5003 50.0006Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5003 50.0006C37.0403 50.0006 36.667 49.6272 36.667 49.1672V45.0006C36.667 44.5406 37.0403 44.1672 37.5003 44.1672C37.9603 44.1672 38.3337 44.5406 38.3337 45.0006V49.1672C38.3337 49.6272 37.9603 50.0006 37.5003 50.0006Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5003 35.8338C42.0403 35.8338 41.667 35.4605 41.667 35.0005V30.8338C41.667 30.3738 42.0403 30.0005 42.5003 30.0005C42.9603 30.0005 43.3337 30.3738 43.3337 30.8338V35.0005C43.3337 35.4605 42.9603 35.8338 42.5003 35.8338Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5003 35.8338C37.0403 35.8338 36.667 35.4605 36.667 35.0005V30.8338C36.667 30.3738 37.0403 30.0005 37.5003 30.0005C37.9603 30.0005 38.3337 30.3738 38.3337 30.8338V35.0005C38.3337 35.4605 37.9603 35.8338 37.5003 35.8338Z",
    fill: "#C0C0D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_810_10947",
    x1: 40,
    y1: 0.000488281,
    x2: 40,
    y2: 80.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_810_10947",
    x1: 40,
    y1: 0.000488281,
    x2: 40,
    y2: 80.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_10947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20.0005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg1);
export default __webpack_public_path__ + "static/media/productivityimg1.fef1f4aafd7ca943f4b654eb1fba1aab.svg";
export { ForwardRef as ReactComponent };